import { useEffect, type RefObject } from 'react';
import { scrollTabToCenter } from '../utils/get-tab-scroll-px';

/**
 * Simple hook to center tab when tab index changes
 */
export function useTabCentering(
  tabListRef: RefObject<HTMLDivElement>,
  tabIndex: number
) {
  useEffect(() => {
    scrollTabToCenter({
      ref: tabListRef,
      tabIndex,
    });
  }, [tabListRef, tabIndex]);
}
